import { render, staticRenderFns } from "./VoucherPage.vue?vue&type=template&id=b168749e&scoped=true"
import script from "./VoucherPage.vue?vue&type=script&lang=js"
export * from "./VoucherPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b168749e",
  null
  
)

export default component.exports